import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "f7b121c0-a9d5-4e2c-9831-8062cd10dbff", content: "Ear canal", options: {} },
  { id: "b843d065-a549-4d57-b433-f2a6d4f30bbc", content: "Torso", options: {} },
  { id: "8a25fbd4-6ae6-42c3-bd4c-914b4fdf8801", content: "Cavum Cochae", options: {} },
  { id: "644995b2-92f2-4265-a05d-a51916ff34d4", content: "Head", options: {} },
  { id: "e54ce20e-752b-423f-8c60-1efb3f906032", content: "Shoulder", options: {} },
  { id: "c024ef32-42d5-4127-a026-c03c2c597fd9", content: "Pinna", options: {} },
];

export const task: Task = {
  id: "a158542f-964d-4237-b2a4-efefc8b0029b",
  solutionType: "equal-ordered-text-or-number-array",
  type: "custom021300",
  options: {
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "equal-ordered-text-or-number-array",
  data: [
    "b843d065-a549-4d57-b433-f2a6d4f30bbc",
    "644995b2-92f2-4265-a05d-a51916ff34d4",
    "e54ce20e-752b-423f-8c60-1efb3f906032",
    "c024ef32-42d5-4127-a026-c03c2c597fd9",
    "8a25fbd4-6ae6-42c3-bd4c-914b4fdf8801",
    "f7b121c0-a9d5-4e2c-9831-8062cd10dbff",
  ],
};
